import videojs from 'video.js'

let installed = false

/** 只给 HLS 密钥请求带上登录令牌，切片请求仍走阿里云，避免触发跨域预检。 */
export function installHlsKeyAuth() {
  if (installed) return
  const xhr = videojs.Vhs && videojs.Vhs.xhr
  if (!xhr) return
  installed = true
  const prev = xhr.beforeRequest
  xhr.beforeRequest = function (opts) {
    if (typeof prev === 'function') {
      const next = prev(opts)
      if (next) opts = next
    }
    const uri = String((opts && (opts.uri || opts.url)) || '')
    if (uri.includes('/knowledge/media/oss/hls-key')) {
      const token = localStorage.getItem('jwt_token')
      if (token) {
        opts.headers = opts.headers || {}
        opts.headers.Authorization = 'Bearer ' + token
      }
    }
    return opts
  }
}
